import { gaPushEvent } from "../base.analytics";

enum Event {
  SEARCH_FILTER = "filter",
  CONTENT_FILTER = "set_filter",
}

type FilterPayload = {
  name: string;
  value: string;
};

type AnalyticsTag = {
  id: string;
  uid: string;
  parent?: string | null;
};

type SpecialtyItemPayload = {
  specialty: AnalyticsTag;
  tags: AnalyticsTag[];
};

type SpecialtyItemListPayload = {
  specialties: AnalyticsTag[];
  tags: AnalyticsTag[];
};

type FiltersItemReturnData = {
  item_id: string;
  item_name: string;
  item_category: string;
  item_list_name: string;
  item_list_id: string;
};

function convertSpecialtyToItemData(
  payload: SpecialtyItemPayload
): FiltersItemReturnData {
  const { specialty, tags } = payload;
  const subSpecialties = tags
    .filter((tag) => tag.parent === specialty.id)
    .map((tag) => tag.uid)
    .join(",");

  return {
    item_id: specialty.id,
    item_name: specialty.uid,
    item_category: subSpecialties.length > 0 ? subSpecialties : specialty.uid,
    item_list_name: "filters", // NOTE: Static.
    item_list_id: "filters", // NOTE: Static.
  };
}

export function gaEventSetFilter(
  payload: SpecialtyItemListPayload & { roomName?: string | null }
) {
  gaPushEvent(Event.CONTENT_FILTER, {
    applied_filter:
      payload.tags.length > 0
        ? payload.tags.map((t) => t.uid)
        : payload.specialties.map((s) => s.uid),
    room_name: payload.roomName ?? null,
    ecommerce: {
      items: payload.specialties.map((specialty) => {
        return convertSpecialtyToItemData({
          specialty,
          tags: payload.tags,
        });
      }),
    },
  });
}

// Room discovery filter. Emits the same `set_filter` event as the specialty/tag
// filter, so downstream reporting stays uniform. `keys` are the applied filter
// keys (topic uids, or tag ids for the un-migrated fallback — both surfaced as
// topic filtering), plus how they combine (any/all).
export function gaEventSetTopicFilter(payload: {
  keys: string[];
  matchMode: "any" | "all";
  roomName?: string | null;
}) {
  gaPushEvent(Event.CONTENT_FILTER, {
    applied_filter: payload.keys,
    match_mode: payload.matchMode,
    room_name: payload.roomName ?? null,
    ecommerce: {
      items: payload.keys.map((key) => ({
        item_id: key,
        item_name: key,
        item_category: key,
        item_list_name: "filters",
        item_list_id: "filters",
      })),
    },
  });
}

// TODO: Use in search + move to search analytics?
export function gaEventFilter(payload: FilterPayload) {
  gaPushEvent(Event.SEARCH_FILTER, {
    filter: {
      filter_name: payload.name,
      filter_value: payload.value,
    },
  });
}
